"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconSizeMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../components/Icon/Icon.styles");
/** @mixin iconSizeMixin */
/**
 * Gives icon children an explicit size.
 *
 * @example
 * import { iconSizeMixin, IconHeart } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${iconSizeMixin}
 * `;
 *
 * <Component iconSize="sm">A small icon: <IconHeart /></Component>
 *
 * @method
 * @param props {object}
 * @param props.iconSize {string|number} The icon size.
 * @param props.theme {object} The styled-components theme.
 * @return {CSSObject}
 */
var iconSizeMixin = function iconSizeMixin(props) {
  var iconSize = props.iconSize;
  return (0, _styledToken.default)('icons.sizes', function (iconSizes) {
    if (!iconSizes) {
      return '';
    }
    var size = iconSizes[iconSize] || iconSize;
    return (0, _styledComponents.css)(["> ", "{display:block;height:", "px;width:", "px;}"], _Icon.StyledIcon, size, size);
  })(props);
};
exports.iconSizeMixin = iconSizeMixin;